module.exports = __webpack_public_path__ + "img/bg-plan-item-3.4fd9c043.png";